<button mat-button
        [matMenuTriggerFor]="languageMenu"
        class="language-switcher__button">
    <img *ngIf="currentLanguage?.countryFlag as flag"
         [src]="flag"
         class="language-switcher__flag"
         alt="">
    {{ currentLanguage?.name }}
    <mat-icon>arrow_drop_down</mat-icon>
</button>

<mat-menu #languageMenu="matMenu">
    <button mat-menu-item
            *ngFor="let lang of languages"
            (click)="onSelectLanguage(lang)"
            [class.language-switcher__item--active]="lang.tag === languageService.currentLocale">
        <img *ngIf="lang.countryFlag as flag"
             [src]="flag"
             class="language-switcher__flag"
             alt="">
        {{ lang.name }}
    </button>
</mat-menu>
